/**
 * Route Shopify Standard Actions through the same confirmed-cart coordinator
 * used by the theme's Ajax forms. This is the only non-Ajax mutation entry
 * point; it must not retain a second section renderer or publish path.
 */
function initStandardActions() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.openCart.configure({
    async handler(defaultHandler) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
      return defaultHandler();
    },
  });

  actions.updateCart.configure({
    eventTarget: () => document,
    async handler(defaultHandler) {
      // Standard Actions performs its Storefront API mutation inside
      // defaultHandler. Enqueue it so it cannot race an Ajax add/change/remove.
      if (typeof CartItems !== 'undefined') {
        let actionResult;
        await CartItems.enqueueMutation(async () => {
          actionResult = await defaultHandler();
        }, { source: 'standard-actions' });
        return actionResult;
      }
      return defaultHandler();
    },
  });
}

if (window.Shopify?.actions) {
  initStandardActions();
} else {
  document.addEventListener('DOMContentLoaded', initStandardActions, { once: true });
}
